import { Component, OnInit } from '@angular/core';
import { BookingAccommodationService } from '../service/booking-accommodation.service';
import { HttpService } from '../service/http.service';
import { BookingService } from '../service/booking.service';
import { InternalBookingComment } from '../internal-booking-comment';
import { ToastMessageService } from '../toast-message.service';
import { UserService } from '../service/user.service';
import { ApiError } from '../api-error';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-booking-accommodation',
  templateUrl: './booking-accommodation.component.html',
  styleUrls: ['./booking-accommodation.component.css']
})
export class BookingAccommodationComponent implements OnInit {

  constructor(
    public bookingAccommodationService: BookingAccommodationService,
    private httpService: HttpService,
    public bookingService: BookingService,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService,
    public userService: UserService
  ) { }

  ngOnInit(): void {
  }

  submitChange() {
    this.bookingAccommodationService.updateAccommodation();
    this.httpService.updateBookingAccommodation(this.bookingService.booking.accommodation, this.bookingService.booking.id!).subscribe(res => {
      this.bookingService.booking.accommodation.versionId = res;
      this.toastService.addSuccess("Success", "Accommodation updated");
      this.bookingService.sendingUpdateRequest = false;
    }, error => {
      this.toastService.addError("Error", new ApiError(error).message);
      this.bookingService.sendingUpdateRequest = false;
    });
    if (this.bookingAccommodationService.accommodationForm.value.internalComment) {
      this.postInternalComment();
    }
  }

  postInternalComment() {
    if (this.bookingAccommodationService.accommodationForm.get("internalComment")!.invalid) {
      this.toastService.addError("Error", "Form value invalid");
      return;
    }
    this.httpService.postInternalBookingComment(new InternalBookingComment(
      this.bookingAccommodationService.accommodationForm.value.internalComment,
      false
    ), this.bookingService.booking.id!).subscribe(comment => {
      this.bookingService.booking.internalCommentList.unshift(comment);
      this.bookingAccommodationService.accommodationForm.get("internalComment")!.reset();
    });
  }

  deleteComment(comment: InternalBookingComment) {
    this.confirmationService.confirm({
      header: "Delete your post",
      message: "Do you want to delete your post ID: " + comment.id + "?",
      accept: () => {
        this.httpService.deleteInternalBookingComment(comment.id!).subscribe(() => {
          this.bookingService.booking.internalCommentList = this.bookingService.booking.internalCommentList.filter((item) => {
            return item.id != comment.id;
          });
          this.toastService.addSuccess("Success", "Your post is deleted !");
        }, error => {
          this.toastService.addError("Error", error.error.message);
        });
      }
    })
  }

}
